// extracted by mini-css-extract-plugin
module.exports = {"image":"svg-icon_image__2PjNo","loaded":"svg-icon_loaded__1m46g","cached":"svg-icon_cached__1cUZ8"};